import React, { useState } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, CheckIcon } from 'lucide-react';
import Button from './Button';
import { sendWebhookData } from '../services/webhook';
import { useNavigate } from 'react-router-dom';
const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      // Send data to webhook
      const success = await sendWebhookData({
        ...formData,
        formType: 'contact_demo'
      });
      if (success) {
        console.log('Form submitted successfully:', formData);
        setIsSubmitted(true);
        setFormData({
          name: '',
          email: '',
          company: '',
          phone: '',
          message: ''
        });
        // Redirect to thank you page
        setTimeout(() => {
          navigate('/thank-you');
        }, 1000);
      } else {
        alert('There was an issue submitting your request. Please try again.');
      }
    } catch (error) {
      console.error('Error during form submission:', error);
      alert('There was an error submitting your request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section className="py-16 bg-white" data-id="element-1074">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1075">
        <div className="text-center mb-12" data-id="element-1076">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1077">Book a Demo</h1>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1078">
            Ready to see Shopilots in action? Fill out the form below and our
            team will get back to you within 24 hours to schedule a personalized
            demo.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1079">
          {/* Contact Information */}
          <div className="lg:col-span-1" data-id="element-1080">
            <div className="bg-accent/50 rounded-xl p-8 h-full" data-id="element-1081">
              <h3 className="text-2xl font-bold mb-6" data-id="element-1082">Contact Information</h3>
              <div className="space-y-6" data-id="element-1083">
                <div className="flex items-start" data-id="element-1084">
                  <div className="bg-white p-3 rounded-full mr-4" data-id="element-1085">
                    <MapPinIcon className="h-6 w-6 text-primary" data-id="element-1086" />
                  </div>
                  <div data-id="element-1087">
                    <h4 className="font-semibold" data-id="element-1088">Our Location</h4>
                    <p className="text-gray-600" data-id="element-1089">
                      Located in: Westfield Bondi Junction
                    </p>
                    <p className="text-gray-600" data-id="element-1090">
                      Level 1/9/13 Bronte Rd, Bondi Junction NSW 2022
                    </p>
                    <p className="text-gray-600" data-id="element-1091">Australia</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1092">
                  <div className="bg-white p-3 rounded-full mr-4" data-id="element-1093">
                    <PhoneIcon className="h-6 w-6 text-primary" data-id="element-1094" />
                  </div>
                  <div data-id="element-1095">
                    <h4 className="font-semibold" data-id="element-1096">Phone</h4>
                    <p className="text-gray-600" data-id="element-1097">+1 (914) 601-1670</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1098">
                  <div className="bg-white p-3 rounded-full mr-4" data-id="element-1099">
                    <MailIcon className="h-6 w-6 text-primary" data-id="element-1100" />
                  </div>
                  <div data-id="element-1101">
                    <h4 className="font-semibold" data-id="element-1102">Email</h4>
                    <p className="text-gray-600" data-id="element-1103">ben@shopilots.com</p>
                  </div>
                </div>
              </div>
              <div className="mt-10" data-id="element-1104">
                <h4 className="font-semibold mb-2" data-id="element-1105">Working Hours</h4>
                <p className="text-gray-600" data-id="element-1106">Sunday - Friday: 9AM - 6PM EST</p>
              </div>
            </div>
          </div>
          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-1107">
            <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-1108">
              {isSubmitted ? <div className="text-center py-12" data-id="element-1109">
                  <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6" data-id="element-1110">
                    <CheckIcon className="h-8 w-8 text-primary" data-id="element-1111" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2" data-id="element-1112">Thank You!</h3>
                  <p className="text-gray-600 mb-6" data-id="element-1113">
                    Your message has been received. Our team will contact you
                    shortly to schedule your personalized demo.
                  </p>
                  <Button variant="primary" onClick={() => setIsSubmitted(false)} data-id="element-1114">
                    Send Another Message
                  </Button>
                </div> : <form onSubmit={handleSubmit} data-id="element-1115">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1116">
                    <div data-id="element-1117">
                      <label htmlFor="name" className="block text-sm font-medium text-primary mb-1" data-id="element-1118">
                        Full Name *
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary text-primary" placeholder="John Doe" data-id="element-1119" />
                    </div>
                    <div data-id="element-1120">
                      <label htmlFor="email" className="block text-sm font-medium text-primary mb-1" data-id="element-1121">
                        Email Address *
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary text-primary" placeholder="john@example.com" data-id="element-1122" />
                    </div>
                    <div data-id="element-1123">
                      <label htmlFor="company" className="block text-sm font-medium text-primary mb-1" data-id="element-1124">
                        Company Name *
                      </label>
                      <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary text-primary" placeholder="Acme Inc." data-id="element-1125" />
                    </div>
                    <div data-id="element-1126">
                      <label htmlFor="phone" className="block text-sm font-medium text-primary mb-1" data-id="element-1127">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary text-primary" placeholder="+1 (555) 123-4567" data-id="element-1128" />
                    </div>
                  </div>
                  <div className="mb-6" data-id="element-1129">
                    <label htmlFor="message" className="block text-sm font-medium text-primary mb-1" data-id="element-1130">
                      Message *
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary text-primary" placeholder="Tell us about your business needs and what you're looking for in an AI shopping advisor..." data-id="element-1131"></textarea>
                  </div>
                  <Button variant="primary" type="submit" fullWidth disabled={isSubmitting} data-id="element-1132">
                    {isSubmitting ? 'Sending...' : 'Request Demo'}
                  </Button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ContactUs;